<template>
  <div
    class="text-[2.25rem] leading-[2.5rem] font-black text-[#433D31] pb-[24px] tracking-[-1.08px]"
  >
    HOGC updates
  </div>
</template>

<script>
export default {};
</script>
